// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1701":"css/app.6967","6774":"css/admin-app.6967"}[chunkId] + ".css";
};